export const NODE_RIBBONS = 'carruseles {{NODE_NAME}}';
export const BUTTON_GROUP = 'BUTTON_GROUP';



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonCategories/constants.js